module.exports = {
  title: '主题摄影征集活动',
  baseUrl: '', // 测试项目地址
  baseApi: '', // 测试api请求地址
  APPID: '',
  APPSECRET: '',
  $cdn: ''
}
